module.exports = __webpack_public_path__ + "images/bg-btn.9d1297dd04481ca2c36d9dbd94e0b5b7.png";